export default __webpack_public_path__ + "static/media/cosmetic_white.0b27beda.svg";